// File: SummaryPanel
// Created: 2026-05-14
// Updated: 2026-05-29
// Author: Erick Hernández Silva

import React from 'react';
import type { CarConfig, Option, SubOption } from './carWizardTypes';

interface Props {
  car: CarConfig;
  hiddenStepIds: Set<string>;
  getSelectedOption: (stepId: string) => Option | null;
  getActiveSubOption: (stepId: string) => SubOption | null;
}

const SummaryPanel: React.FC<Props> = ({ car, hiddenStepIds, getSelectedOption, getActiveSubOption }) => {
  return (
    <>
      <div className="p-4 md:p-6 pb-0">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Configuration Summary</h2>
      </div>

      <div className="overflow-y-auto px-4 md:px-6 max-h-[calc(100vh-520px)] lg:max-h-[calc(100vh-150px)]">
        <div className="space-y-4 mb-6">
          {car.steps.map((step) => {
            if (hiddenStepIds.has(step.stepId)) return null;
            const option = getSelectedOption(step.stepId);
            if (!option) return null;
            const subOption = getActiveSubOption(step.stepId);
            // Coupled (disposition-only) variants never show a price.
            const hideSubPrice = !!option.subOptionsLinkedToStepId;

            return (
              <div key={step.stepId} className="border-b border-gray-200 pb-3">
                <div className="text-xs text-gray-500 mb-1">{step.stepName}</div>
                <div className="flex justify-between items-start">
                  <div>
                    <div className="text-sm font-medium text-gray-900">{option.optionName}</div>
                    {subOption && (
                      <div className="text-xs text-gray-600 mt-1">→ {subOption.optionName}</div>
                    )}
                  </div>
                  <div className="text-right">
                    <div className="text-sm text-gray-900">
                      {option.optionPrice > 0 ? '+' : ''}${option.optionPrice}
                    </div>
                    {subOption && subOption.optionPrice !== 0 && !hideSubPrice && (
                      <div className="text-xs text-gray-600">
                        {subOption.optionPrice > 0 ? '+' : ''}${subOption.optionPrice}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default SummaryPanel;
